<main class="modal-user">
  <a
    class="link-cancel"
    mat-icon-button
    matTooltip="Cancelar"
    (click)="cancel()"
    matTooltipPosition="left"
  >
    <mat-icon>close</mat-icon>
  </a>
  <form [formGroup]="formGroup" (ngSubmit)="submit()">
    <div mat-dialog-content>
      <mat-card>
        <div class="row">
          <h4>Por favor, qual é o e-mail do usuário?</h4>
          <div class="col-12 col-sm-12">
            <mat-card-content>
              <mat-form-field>
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="email" />
              </mat-form-field>
            </mat-card-content>
          </div>
        </div>
      </mat-card>
    </div>
    <div mat-dialog-actions>
      <div class="login__actions">
        <button mat-button type="submit" class="btn-submit-dark">Avançar</button>
      </div>
    </div>
  </form>
</main>
